import { render } from "./CheckboxTable.vue?vue&type=template&id=d982b5a4"
import script from "./CheckboxTable.vue?vue&type=script&lang=js"
export * from "./CheckboxTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__